import { forwardRef, type Ref, type SVGProps } from "react";
const IconIdCardOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M10 12.265a2.02 2.02 0 0 1 2 0 1.97 1.97 0 0 1 1 1.709v.402a2.73 2.73 0 0 1-.857 1.915l.57.112c1.355.316 2.287.993 2.287 1.78v2.253a.57.57 0 0 1-.571.564H7.57a.57.57 0 0 1-.57-.564v-2.253c0-.787.932-1.464 2.286-1.78.014-.003.378-.082.571-.112-.532-.5-.84-1.19-.857-1.915v-.402a1.97 1.97 0 0 1 1-1.71" />
    <path d="M24 19a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2z" />
    <path d="M24 16a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2z" />
    <path d="M22 12a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2z" />
    <path
      fillRule="evenodd"
      d="M26.204 8.01A2 2 0 0 1 28 10v12l-.01.204a2 2 0 0 1-1.786 1.785L26 24H6a2 2 0 0 1-1.99-1.796L4 22V10a2 2 0 0 1 2-2h20zM6 22h20V10H6z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconIdCardOutlineSVG);
ForwardRef.displayName = "IconIdCardOutline";
export { ForwardRef as IconIdCardOutline };
